document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded',()=>{
  const dropdowns=[...document.querySelectorAll('.v-nav-dropdown')];
  dropdowns.forEach(dropdown=>dropdown.addEventListener('toggle',()=>{if(dropdown.open)dropdowns.forEach(other=>{if(other!==dropdown)other.removeAttribute('open')})}));
  document.addEventListener('click',event=>{if(!event.target.closest('.v-nav-dropdown'))dropdowns.forEach(dropdown=>dropdown.removeAttribute('open'))});
  const maker=document.querySelector('[data-maker-shell]');
  const setMaker=(isOpen)=>{
    if(!maker)return;
    maker.classList.toggle('is-open',isOpen);
    document.body.classList.toggle('v-maker-open',isOpen);
    if(isOpen){maker.scrollTop=0;history.replaceState(null,'','#CustomPieceMaker');const closeMaker=maker.querySelector('[data-custom-maker-close]');if(closeMaker)closeMaker.focus()}
    else if(location.hash==='#CustomPieceMaker')history.replaceState(null,'',location.pathname+location.search);
  };
  document.querySelectorAll('[data-custom-maker-open]').forEach(link=>link.addEventListener('click',event=>{if(maker){event.preventDefault();setMaker(true)}}));
  document.querySelectorAll('[data-custom-maker-close]').forEach(button=>button.addEventListener('click',()=>setMaker(false)));
  if(maker&&location.hash==='#CustomPieceMaker')setMaker(true);
  const open=document.querySelector('[data-menu-open]');
  const close=document.querySelector('[data-menu-close]');
  const menu=document.querySelector('#VoltaireMenu');
  if(!open||!close||!menu)return;
  const setMenu=(isOpen)=>{menu.classList.toggle('is-open',isOpen);menu.setAttribute('aria-hidden',String(!isOpen));open.setAttribute('aria-expanded',String(isOpen));document.body.classList.toggle('v-menu-open',isOpen);if(isOpen)close.focus()};
  open.addEventListener('click',()=>setMenu(true));
  close.addEventListener('click',()=>setMenu(false));
  menu.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>setMenu(false)));
  document.addEventListener('keydown',event=>{if(event.key==='Escape'){setMenu(false);setMaker(false)}});
});
